@let membersDataValue = membersData();

<rt-dialog-header
  [heading]="'tlc.members.add_team_member_without_access_dialog.heading' | translate"
  [subheading]="'tlc.members.add_team_member_without_access_dialog.subheading' | translate"
/>
<rt-dialog-body variant="white">
  <div class="cards-container">
    @for (member of membersDataValue; track $index) {
      <tlc-member-box [member]="member" />
    }
  </div>
</rt-dialog-body>
<rt-dialog-footer variant="white">
  <rt-button variant="plain" (click)="cancel()">{{ 'tlc.common.cancel' | translate }}</rt-button>
  <rt-button variant="primary" [loading]="isLoading()" (click)="proceed()">
    @if (membersDataValue?.length === 1) {
      {{ 'tlc.members.add_employee_without_access_dialog.add_team_member_cta.one' | translate }}
    } @else {
      {{
        'tlc.members.add_employee_without_access_dialog.add_team_member_cta.other'
          | translate: { count: membersDataValue!.length }
      }}
    }
  </rt-button>
</rt-dialog-footer>
